import { withAuthenticationRequired } from '@auth0/auth0-react'
import { ComponentType, useMemo } from 'react'

interface AuthenticationGuardProps {
  component: ComponentType
}

export const AuthenticationGuard = ({ component }: AuthenticationGuardProps) => {
  const Component = useMemo(() => withAuthenticationRequired(component, {}), [component])

  return <Component />
}
